@if (isDisabled) {
  <nb-form-field>
    <input nbInput
           [fieldSize]="size()"
           type="text"
           placeholder="Gebäude suchen"
           [ngModel]="value?.baseData?.sectionText"
           fullWidth
           [disabled]="true" />
    @if (value) {
      <button nbSuffix
              [size]="size()"
              nbButton
              ghost
              (click)="goToBuilding()"
              nbTooltip="Zum Gebäude">
        <nb-icon icon="external-link-outline"
                 pack="eva">
        </nb-icon>
      </button>
    }
  </nb-form-field>
} @else {
  <nb-form-field>
    <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
    <input nbInput
           type="text"
           [fieldSize]="size()"
           #searchInput
           [(ngModel)]="filterText"
           placeholder="Gebäude suchen"
           [nbPopover]="popoverTemplate"
           [nbPopoverPlacement]="'bottom-end'"
           [nbPopoverTrigger]="'focus'"
           (keydown.enter)="$event.preventDefault()"
           fullWidth />
    @if (value) {
      <button nbSuffix nbButton ghost (click)="clear()">
        <nb-icon icon="close-outline"
                 pack="eva">
        </nb-icon>
      </button>
    }
  </nb-form-field>

  <ng-template #popoverTemplate>
    <div class="autocomplete-dropdown">
      <nb-list nbInfiniteList (bottomThreshold)="loadMore()" [threshold]="50" [throttleTime]="100">
        @for (building of buildings(); track building.id) {
          <nb-list-item (click)="onSelectionChange(building)">
            <div class="building">
              <nb-icon icon="home" pack="fas"></nb-icon>
              <div class="title-and-subtitle">
                <div class="title">{{ building.baseData.sectionText }}</div>
                <div class="subtitle">
                  <div class="value">
                    <nb-icon icon="hash" pack="eva"></nb-icon>
                    {{ building.internalNumber }}
                  </div>
                  <div class="value">
                    <nb-icon icon="crop" pack="eva"></nb-icon>
                    {{ building.baseData.area | number: '1.2-2' }}
                  </div>
                  <div class="value">
                    <nb-icon icon="globe-outline" pack="eva"></nb-icon>
                    {{ building.ownerTenant.name }}
                  </div>
                  <div class="value">
                    <nb-icon icon="people" pack="eva"></nb-icon>
                    {{ building.team?.name }}
                  </div>
                </div>
              </div>
            </div>
          </nb-list-item>
        }
      </nb-list>
    </div>
  </ng-template>
}
